export class UserQuestions
{
    affiliation = "";
    role = "";
    country = "";
    state = "";
}